import React from 'react';
import { Row, Col, Alert } from 'antd';
import { useFormContext } from 'react-hook-form';
import FormField from '../../shared/FormField';
import { formatBRL } from '../../../utils/currency';

export default function Step3Confirmacao() {
  const { watch } = useFormContext();

  const tipoSolicitacao = watch('tipo_solicitacao');
  const nomeCompleto = watch('nome_completo');
  const potencia = watch('potencia_adquirida_kwp');
  const valorProposta = watch('valor_proposta');
  const descricaoPagamento = watch('descricao_pagamento');
  const isVenda = tipoSolicitacao === 'VendaConcluida';

  return (
    <div>
      <div className="border rounded-lg p-4 mb-4">
        <h3 className="text-lg font-semibold mb-4">Resumo</h3>

        <Alert
          type="info"
          className="mb-4"
          message="Revise os dados antes de enviar"
          description="Após o envio, o formulário será analisado pela equipe de engenharia."
        />

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <p className="text-sm text-gray-500">Tipo de Solicitação</p>
            <p className="font-medium">{tipoSolicitacao === 'VendaConcluida' ? 'Venda Concluída' : 'Homologação Prévia'}</p>
          </div>
          {isVenda && nomeCompleto && (
            <div>
              <p className="text-sm text-gray-500">Cliente</p>
              <p className="font-medium">{nomeCompleto}</p>
            </div>
          )}
          <div>
            <p className="text-sm text-gray-500">Potência</p>
            <p className="font-medium">{potencia} kWp</p>
          </div>
          {isVenda && valorProposta && (
            <div>
              <p className="text-sm text-gray-500">Valor da Proposta</p>
              <p className="font-medium">{formatBRL(valorProposta)}</p>
            </div>
          )}
        </div>

        {descricaoPagamento && (
          <div className="mb-4 p-3 bg-gray-50 rounded">
            <p className="text-sm text-gray-500 mb-1">Forma de Pagamento</p>
            <p className="text-sm">{descricaoPagamento}</p>
          </div>
        )}
      </div>

      <div className="border rounded-lg p-4 mb-4">
        <h3 className="text-lg font-semibold mb-4">Confirmação</h3>

        <FormField name="observacoes_finais" label="Observações Finais" textarea />

        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <FormField
              name="data_contrato"
              label="Data do Contrato"
              type="date"
              disabled
            />
          </Col>
          <Col xs={24} sm={8}>
            <FormField name="nome_verificador" label="Nome do Verificador" disabled />
          </Col>
          <Col xs={24} sm={8}>
            <FormField name="email_verificador" label="Email do Verificador" disabled />
          </Col>
        </Row>
      </div>
    </div>
  );
}
